//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetEventList } from "@/api";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      eventShow:false,
      curIndex: 0,
      activetyList: [],
      isActive: "",
    };
  },
  computed: {
    ...mapState(["config"]),
  },
  watch: {},
  created() {
    this.GetEventList();
  },
  mounted() {},
  methods: {
    GetEventList() {
      GetEventList({ current: 1, size: 999 }).then((res) => {
        this.activetyList = res.data.data.data;
        this.curIndex = 0;
      });
    },
  },
};
